import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import {
  TGroupChatHasHistoryRequest,
  TGroupChatHasHistoryResponse,
} from "../../api/group_chat/has_history";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";

export type TApiGroupChatHasHistoryResult = {
  result?: TGroupChatHasHistoryResponse;
};

export const fetchGroupChatHasHistory = async (
  params: TGroupChatHasHistoryRequest,
): Promise<TApiResult & TApiGroupChatHasHistoryResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;

  return await client()
    .group_chat.has_history.post({
      body: params,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      if (res.body.status_code !== 0) {
        return {
          isSuccess: false,
          status: res.body.status_code,
          message: res.body.message,
        };
      }
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(
        e,
        "fetchGroupChatHasHistory",
      );
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
